import React, {useState,useEffect} from 'react';
import {HashRouter as Router, Route, Routes, Navigate} from "react-router-dom";
import router from './router/router';
import './App.css';
import {ConfigProvider,theme,Layout  } from "antd";
import { useSelector,useDispatch } from 'react-redux';
import {setAllContextMeta} from './store/modules/user'
import {getAllContextMeta} from './api/other'
import HeaderApp from './comm/head'
import LeftApp from './comm/left'
import RightApp from './comm/right'
import FooterApp from './comm/footer'
import HomeApp from './pages/Home/Index'
import TranslateApp from './pages/Home/Translate'
import ErrorCorrectionApp from './pages/Home/ErrorCorrection'
import AnalysisApp from './pages/Home/Analysis'
import ChatApp from './pages/Home/Chat'
import BuyMoreApp from './pages/Home/BuyMore'



const { Header, Sider, Content, Footer } = Layout;

const App = () => {
    const [themeVlue, setThemeVlue] = useState(localStorage.getItem('ai-chat-theme')||'default');
    const [clearContent,setClearContent] = useState(false)
    const handleChangeTheme = ()=>{
        if(localStorage.getItem('ai-chat-theme')==='dark'){
            localStorage.setItem('ai-chat-theme','default')
            setThemeVlue('default')
        }else{
            localStorage.setItem('ai-chat-theme','dark')
            setThemeVlue('dark')
        }
    }
    const appStyle = {
        backgroundColor: themeVlue==='default'?'#fff':'#2c2c2c',
        padding:'0'
    }
    const [collapsedLeft, setCollapsedLeft] = useState(localStorage.getItem('ai-chat-collapsedLeft')?(localStorage.getItem('ai-chat-collapsedLeft')==='open'?false:true):false);
    const [collapsedRight, setCollapsedRight] = useState(localStorage.getItem('ai-chat-collapsedRight')?(localStorage.getItem('ai-chat-collapsedRight')==='open'?false:true):false);
    const [homePageIndex,setHomePageIndex] = useState(localStorage.getItem('ai-chat-homePageIndex')?parseInt(localStorage.getItem('ai-chat-homePageIndex')):0);
    //超话
    const [sendTxt,setSendTxt] = useState(null)
    const handleSend = (v)=>{
        setSendTxt(v)
    }
    const {userInfo,allContextMeta} = useSelector(state=>state.user)
    const dispatch = useDispatch()

    useEffect(()=>{
        if(userInfo&&!allContextMeta){
            getAllContextMetas()
        }
    },[])
    //所有语境
    const getAllContextMetas =()=>{
        getAllContextMeta().then(res=>{
            if(res.code === 200){
                dispatch(setAllContextMeta(res.data))
            }
        })
    }
    useEffect(()=>{
        if(collapsedLeft&&collapsedRight){
            document.getElementsByClassName('App')[0].style.minWidth = '802px'
        }else if(!collapsedLeft&&!collapsedRight){
            document.getElementsByClassName('App')[0].style.minWidth = '802px'
        }else if(!collapsedLeft&&collapsedRight){
            document.getElementsByClassName('App')[0].style.minWidth = '802px'
        }else if(collapsedLeft&&!collapsedRight){
            document.getElementsByClassName('App')[0].style.minWidth = '802px'
        }
    },[collapsedLeft,collapsedRight])
    return (
        <Router>
            <ConfigProvider
				theme={{
				    components: { Input: {activeBorderColor:'#88993d',hoverBorderColor:'#88993d' }},
                    algorithm:themeVlue==='dark'?theme.darkAlgorithm:theme.defaultAlgorithm,
                }}>
                <div className="App" style={appStyle}>
                    <Layout style={appStyle}>
                        <Sider width="240" trigger={null} collapsible collapsed={collapsedLeft} style={appStyle} collapsedWidth={0}>
                            <LeftApp themeVlue={themeVlue} homePageIndex={homePageIndex} collapsedLeft={collapsedLeft} setCollapsedLeft={setCollapsedLeft} setHomePageIndex={setHomePageIndex}/>
                        </Sider>
                        <Layout>
                            <Header style={appStyle} >
                                <HeaderApp collapsedRight={collapsedRight} setCollapsedRight={setCollapsedRight} collapsedLeft={collapsedLeft} setCollapsedLeft={setCollapsedLeft} homePageIndex={homePageIndex} setHomePageIndex={setHomePageIndex} setClearContent={setClearContent}/>
                            </Header>
                            <Content style={appStyle} >
								{
									homePageIndex===0?
										<HomeApp themeVlue={themeVlue} setHomePageIndex={setHomePageIndex} homePageIndex={homePageIndex} setClearContent={setClearContent} sendTxt={sendTxt} setSendTxt={setSendTxt} clearContent={clearContent}/>:
										(
											homePageIndex===1?
											<TranslateApp themeVlue={themeVlue} setHomePageIndex={setHomePageIndex} homePageIndex={homePageIndex} setClearContent={setClearContent} sendTxt={sendTxt} setSendTxt={setSendTxt} clearContent={clearContent}/>:
												(
													homePageIndex===2?
														<ErrorCorrectionApp themeVlue={themeVlue} setHomePageIndex={setHomePageIndex} homePageIndex={homePageIndex} setClearContent={setClearContent} sendTxt={sendTxt} setSendTxt={setSendTxt} clearContent={clearContent}/>:
														(
															homePageIndex===3?
																<AnalysisApp themeVlue={themeVlue} setHomePageIndex={setHomePageIndex} homePageIndex={homePageIndex} setClearContent={setClearContent} sendTxt={sendTxt} setSendTxt={setSendTxt} clearContent={clearContent}/>:
																(
																	homePageIndex===4?
																		<ChatApp themeVlue={themeVlue} setHomePageIndex={setHomePageIndex} homePageIndex={homePageIndex} setClearContent={setClearContent} sendTxt={sendTxt} setSendTxt={setSendTxt} clearContent={clearContent}/>:
																		<BuyMoreApp />
																)
														)
												)

										)
								}
							</Content>
                            {
                                homePageIndex===9?'':
                                <Footer style={appStyle}>
                                    <FooterApp themeVlue={themeVlue} homePageIndex={homePageIndex} handleSend={handleSend}/>
                                </Footer>
                            }
                        </Layout>
                        {
                            homePageIndex===9?'':
                                <Sider width="70px" trigger={null} collapsible collapsed={collapsedRight} style={appStyle} collapsedWidth={0}>
                                    <RightApp themeVlue={themeVlue} homePageIndex={homePageIndex} setHomePageIndex={setHomePageIndex} handleChangeTheme={handleChangeTheme} collapsedRight={collapsedRight} setCollapsedRight={setCollapsedRight}/>
                                </Sider>
                        }
                    </Layout>
                </div>
            </ConfigProvider>
        </Router>
    );
}
export default App;
